import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './shared/services/auth.guard';
import { BlankLayoutComponent } from './shared/components/layouts/blank-layout/blank-layout.component';
import { AdminLayoutSidebarCompactComponent } from './shared/components/layouts/admin-layout-sidebar-compact/admin-layout-sidebar-compact.component';
import { AdminLayoutSidebarLargeComponent } from './shared/components/layouts/admin-layout-sidebar-large/admin-layout-sidebar-large.component';

const adminRoutes: Routes = [
  {
    path: 'items',
    loadChildren: () =>  import('./views/items/items.module').then(m=> m.ItemsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'shipments',
    loadChildren: () =>  import('./views/shipments/shipments.module').then(m=> m.ShipmentsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'returns',
    loadChildren: () =>  import('./views/returns/returns.module').then(m=> m.ReturnsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'payment-history',
    loadChildren: () =>  import('./views/payment-history/payment-history.module').then(m=> m.PaymentHistoryModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'support',
    loadChildren: () =>  import('./views/support/support.module').then(m=> m.SupportModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () =>  import('./views/settings/settings.module').then(m=> m.SettingsModule),
    canActivate: [AuthGuard]
  }
];

const routes: Routes = [
{
  path: '',
  redirectTo: 'items/inbox',
  pathMatch: 'full'
},
{
  path: '',
  component: AuthLayoutComponent,
  children: [
    {
      path: 'sessions',
      loadChildren: () => import('./views/sessions/sessions.module').then(m => m.SessionsModule)
    }
  ]
},
{
  path: '',
  component: BlankLayoutComponent,
  children: [
    {
      path: 'others',
      loadChildren: () => import('./views/others/others.module').then(m => m.OthersModule)
    }
  ]
},
{
  path: '',
  component: AdminLayoutSidebarLargeComponent,
  canActivate: [AuthGuard],
  children: adminRoutes
},
{
  path: '**',
  redirectTo: 'others/404'
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
